
import React, { PropTypes, Component } from 'react'
// import Arrow from 'react-icons/lib/io/android-arrow-forward';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import Bookmark from 'react-icons/lib/md/bookmark';
import DropSlider from '../../dropslider';
import { getOffers } from '../../../store/reducers';
import style from './style.css';

class Offers extends Component {
    constructor(props){
        super(props)
        this.state = { posts: null}
    }
    componentWillMount() {
      const { offers } = this.props
      if(!offers){
        this.props.dispatch(getOffers())
      }
    }
    render() {
        const { offers } = this.props
        const posts = offers && offers.slice(0,11)
        return (
            <div className={ style.homeoffers }> 
              <DropSlider showAll={true} title={ "عروض و مسابقات" } count={ 10 }>
                        { posts && posts.map( (node, idx) => {
                            let [a, b, ...s] = node && node.title ? node.title.split(/\./) : []
                            return( 
                                    <div className={ style.innerSlide }  key={`offer_${ idx }`}>
                                        <div className={ style.img } style={{ backgroundImage: `url('${ node.photo_uri }')`}}></div>
                                        <div className={ style.slideContainer }>
                                            <h4 className={ style.slideTitle }>{ node.title }</h4>
                                            <div className={ style.slideContent}> { `${a}...` } </div>
                                            <Link to={`#`} className={ style.learnMore }>إقرأ المزيد</Link>
                                        </div>
                                    </div>
                            )
                    })}
                </DropSlider>
            </div>
        )
    }
}
                                        // <div className={ style.swipeArrows}>
                                        //     <Arrow className={ style.arrowLeft}/>
                                        //     <Arrow className={ style.arrowRight}/>
                                        // </div>

export default connect(s => ({ offers: s.app.offers }))(Offers)



// WEBPACK FOOTER //
// ./src/components/homescreen/offers/index.js